var watchlistPositionList = {
	caption: "Lista de seguimiento de la lista de posiciones",
	name: "Nombre",
	isin: "ISIN",
	lastPrice: "Precio final",
	lastPriceDateTime: "Fecha/Hora",
	perf: "Rendimiento ",
	perfRel: "Rendimiento %",
	volume: "Volume",
	tradingVolume: "Volumen de negociación",
	exchange: "Mercado",
	actions: "Acciones",
	noPositions: "No hay resultados."
};
var es = {
	watchlistPositionList: watchlistPositionList
};

export { es as default, watchlistPositionList };
